import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Globals } from '../globals';
import { Usuario } from '../interfaces/usuario';
import { HttpInterceptor } from '../interceptors/http-interceptor.service';
import { PermisoService } from './permiso.service';
import { GeneralService } from './general.service';

@Injectable()
export class UsuarioService {
  constructor(
    private http: HttpInterceptor,
     private globals: Globals,
        private general: GeneralService,
    private permisoService: PermisoService
  ) { }

  editarUsuario(usuario: Usuario): Observable<any> {
    return this.permisoService.getPermisoAction('USUARIO-EDITAR')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
              usuario: usuario
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  crearUsuario(usuario: Usuario): Observable<any> {
    return this.permisoService.getPermisoAction('USUARIO-CREAR')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
              usuario: usuario
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  getTiposUsuario(
    paginado: any = {
      page: 0,
      pageSize: 10
    },
    orden: any = {
      sort: 'apellido',
      order: 'asc'
    },
    filtros: any = {
      generico: ''
    }
  ): Observable<any> {
    return this.permisoService.getPermisoAction('TIPOS-USUARIO-VER')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
              paginado: paginado,
              orden: orden,
              filtros: filtros
            }));
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  getPuestos(): Observable<any> {
    return this.permisoService.getPermisoAction('PUESTOS-USUARIO-VER')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,JSON.stringify({idCliente:localStorage.getItem('idCliente')
                                      }));
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  getUsuarios(
    paginado: any = {
      page: 0,
      pageSize: 10
    },
    orden: any = {
      sort: 'apellido',
      order: 'asc'
    },
    filtros: any = {
      generico: ''
    }): Observable<any> {
    return this.permisoService.getPermisoAction('USUARIO-VER')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
              paginado: paginado,
              orden: orden,
              filtros: filtros
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  cambiarContrasena(
    contrasenas: any
  ): Observable<any> {
    return this.permisoService.getPermisoAction('USUARIO-CAMBIAR-CONTRASENA')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
              usuario: {
                contrasenaActual: contrasenas.contrasenaActual,
                contrasena: contrasenas.contrasena,
                contrasena2: contrasenas.contrasena2
              }
            })
          )
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  setUsuarioActivo(
    usuario: Usuario
  ): Observable<any> {
    return this.permisoService.getPermisoAction('USUARIO-ESTADO-ACTIVAR')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
              usuario: usuario
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }

  setUsuarioInactivo(
    usuario: Usuario
  ): Observable<any> {
    return this.permisoService.getPermisoAction('USUARIO-ESTADO-INACTIVAR')
      .switchMap((controllerAction) => { // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http
          .post(
            this.general.webserver + controllerAction,
            JSON.stringify({
idCliente:localStorage.getItem('idCliente'),
              usuario: usuario
            })
          );
      })
      .map( // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json());
  }
  
  /**Grupo de usuarios */
  getGrupos(
    paginado: any = {
      page: 0,
      pageSize: 10,
    },
    orden: any = {
      sort: "",
      order: "",
    },
    filtros: any = {
      generico: "",
      tipo: "",
    }
  ): Observable<any> {
    let model = {};
    model['idCliente'] = localStorage.getItem('idCliente');
    return this.http
      .post(
        this.general.webserver + 'apiUsuario/getGrupos',
        JSON.stringify({
          idCliente: localStorage.getItem("idCliente"),
          paginado: paginado,
          orden: orden,
          filtros: filtros,
        })
      ).map(
        (respuesta: Response) => respuesta.json());
  }

  crearGrupo(model: any): Observable<any> {
    return this.http
      .post(
        this.general.webserver + 'apiUsuario/crearGrupo',
        JSON.stringify({
          idCliente: localStorage.getItem('idCliente'),
          grupo: model
        })
      ).map(
        (respuesta: Response) => respuesta.json());
  }

  editarGrupo(model: any): Observable<any> {
    return this.http
      .post(
        this.general.webserver + 'apiUsuario/editarGrupo',
        JSON.stringify({
          idCliente: localStorage.getItem('idCliente'),
          grupo: model
        })
      ).map(
        (respuesta: Response) => respuesta.json());
  }

  eliminarGrupo(model: any): Observable<any> {
    return this.http
      .post(
        this.general.webserver + 'apiUsuario/eliminarGrupo',
        JSON.stringify({
          idCliente: localStorage.getItem('idCliente'),
          grupo: model
        })
      ).map(
        (respuesta: Response) => respuesta.json());
  }

}